import queryString from "query-string";

import { SET_ABSENCE_REASONS, SET_ABSENCE_LIST, SET_ABSENCE_HOURS_LIST, SET_ABSENCE_LIMITS } from "./types";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getReasons = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/absence/reasons`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_ABSENCE_REASONS, payload: response.data });
    }
    catch (error) { errorHandler(error, null); }
};

export const editReasons = (formValues, onFieldError, onSuccess) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/absence/reasons`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) {
            dispatch({ type: SET_ABSENCE_REASONS, payload: response.data });
            onSuccess();
        }
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const getAbsenceList = (filters) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/absence?${queryString.stringify(filters)}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_ABSENCE_LIST, payload: response.data.absence });
    }
    catch (error) { errorHandler(error, null); }
};

export const getHoursList = (filters) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/absence/hours?${queryString.stringify(filters)}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_ABSENCE_HOURS_LIST, payload: response.data.hours });
    }
    catch (error) { errorHandler(error, null); }
};

export const getLimits = () => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/absence/limits`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_ABSENCE_LIMITS, payload: response.data });
    }
    catch (error) { errorHandler(error, null); }
};